import config from '../../config'
import fetcher from '../fetcher'
import type { CompanyContract, CompanyDivision, CompanyFull, CompanySubDivision, CompanyInterview, ApplicantSkill } from './types'
import type { Event } from '../events/types'
import type { Notification } from '../notifications/types'

export const getCompany = async (id: number): Promise<CompanyFull> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/companies/${id}`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching company: ${error}`)
    throw error
  }
}

export const getCompanyDivisions = async (companyId: number): Promise<CompanyDivision[]> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/companies/${companyId}/divisions`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching company divisions: ${error}`)
    throw error
  }
}

export const getCompanySubDivisions = async (companyId: number, divisionId: number): Promise<CompanySubDivision[]> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/companies/${companyId}/divisions/${divisionId}/sub-divisions`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching company divisions: ${error}`)
    throw error
  }
}

export const getCompanySubDivision = async (companyId: number, subDivisionId: number): Promise<CompanySubDivision> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/companies/${companyId}/sub-divisions/${subDivisionId}`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching company sub division ${subDivisionId}: ${error}`)
    throw error
  }
}

export const getPositionContracts = async (companyId: number, divisionId: number, subDivisionId: number, positionId: number): Promise<CompanyContract[]> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/companies/${companyId}/divisions/${divisionId}/sub-divisions/${subDivisionId}/positions/${positionId}/contracts`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching position contracts. Pos id: ${positionId}: ${error}`)
    throw error
  }
}

export const getPositionInterview = async (companyId: number, divisionId: number, subDivisionId: number, positionId: number): Promise<CompanyInterview> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/companies/${companyId}/divisions/${divisionId}/sub-divisions/${subDivisionId}/positions/${positionId}/interviews`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching position interviews. Pos id: ${positionId}: ${error}`)
    throw error
  }
}

export const getCompanyEvents = async (companyId: number): Promise<Event[]> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/companies/${companyId}/events`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching company events: ${error}`)
    throw error
  }
}

export const getCompanyNotifications = async (companyId: number): Promise<Notification[]> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/companies/${companyId}/notifications`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching company notifications: ${error}`)
    throw error
  }
}

export const getAllApplicantSkills = async (companyId: number): Promise<Array<ApplicantSkill>> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/interviews/${companyId}/applicants-skills`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching applicant skills: ${error}`)
    throw error
  }
}
